// TemplateLifecycleState — explicit lifecycle (CLAUDE.md #8). No
// auto-deprecation: TemplateService.certify() does NOT deprecate any prior
// template. Deprecation is always a separate platform_admin call.
import { z } from "zod";
export const TemplateLifecycleStateSchema = z.enum([
    "draft",
    "certified",
    "under_review",
    "re_certified",
    "deprecated",
]);
export const TEMPLATE_LIFECYCLE_STATES = TemplateLifecycleStateSchema.options;
//# sourceMappingURL=TemplateLifecycleState.js.map